<template>
  <div>
    <!-- الكارد الأول: البيانات الرئيسية -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <ValidationObserver v-slot="{ failed, passed }">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">جدول المهام</h4>
                </div>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mtb-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>اسم جدول المهام</label>
                      <md-input v-model="taskScheduleName"></md-input>
                    </md-field>
                  </div>

                  <!-- الموظف -->
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="employeeId"
                      option-value="key"
                      option-text="value"
                      placeholder="الموظف"
                    >
                    </model-list-select>
                  </div>

                  <!-- تاريخ من -->
                  <div
                    class="md-layout-item md-size-15 md-small-size-100 ml-15 mt-25"
                  >
                    <md-datepicker v-model="fromDate" :md-open-on-focus="false">
                      <label class="mr-28">تاريخ من</label>
                    </md-datepicker>
                  </div>

                  <!-- تاريخ إلى -->
                  <div
                    class="md-layout-item md-size-15 md-small-size-100 ml-15 mt-25"
                  >
                    <md-datepicker v-model="toDate" :md-open-on-focus="false">
                      <label class="mr-28">تاريخ إلى</label>
                    </md-datepicker>
                  </div>
                </div>

                <div class="md-layout">
                  <!-- مدة الجدول -->
                  <div
                    class="md-layout-item md-size-25 md-small-size-100 mt-25 ml-15"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="taskScheduleDurations"
                      v-model="taskScheduleDuration"
                      option-value="key"
                      option-text="value"
                      placeholder="نوع الجدول"
                    >
                    </model-list-select>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-checkbox v-model="showTasksNotCompleted">
                      إظهار المهام الغير المنجزة
                    </md-checkbox>
                  </div>
                </div>

                <!-- أزرار الحفظ والجديد -->
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                  >
                    <md-button
                      @click="saveToDB"
                      class="md-success btn_nanosoft"
                    >
                      حفظ
                    </md-button>

                    <md-button @click="goToList" class="md-info btn_nanosoft">
                      جديد
                    </md-button>

                    <!-- v-if="id" -->
                    <md-button
                      @click="openReportDialog"
                      class="md-primary btn_nanosoft"
                    >
                      تقرير PDF
                    </md-button>

                    <!-- <md-button
                      v-if="id && !isConfirmed"
                      @click="confirmTaskSchedule"
                      class="md-primary btn_nanosoft"
                    >
                      اعتماد
                    </md-button>

                    <md-button
                      v-if="id && isConfirmed"
                      @click="unconfirmTaskSchedule"
                      class="md-warning btn_nanosoft"
                    >
                      إلغاء الاعتماد
                    </md-button> -->
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- الكارد الثاني: التفاصيل -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">تفاصيل جدول المهام</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <!-- تفاصيل جدول المهام -->
            <div class="md-layout">
              <!-- تاريخ المهمة -->
              <div
                class="md-layout-item md-size-25 md-small-size-100 ml-15 mt-25"
              >
                <md-datepicker
                  v-model="detail.taskDate"
                  :md-open-on-focus="false"
                >
                  <label class="mr-28">تاريخ المهمة</label>
                </md-datepicker>
              </div>

              <!-- نوع المهمة -->
              <div
                class="md-layout-item md-size-20 md-small-size-100 ml-15 mtb-25"
              >
                <model-list-select
                  class="input-must-rtl"
                  :list="typesOfTasks"
                  v-model="detail.typeOfTaskId"
                  option-value="key"
                  option-text="value"
                  placeholder="اسم المهمة"
                >
                </model-list-select>
              </div>

              <!-- وصف المهمة -->
              <div
                class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
              >
                <md-field>
                  <label>وصف المهمة</label>
                  <md-input v-model="detail.taskDescription"></md-input>
                </md-field>
              </div>

              <!-- مكان العمل -->
              <div
                class="md-layout-item md-size-20 md-small-size-100 ml-15 mtb-25"
              >
                <model-list-select
                  class="input-must-rtl"
                  :list="workPlaces"
                  v-model="detail.workPlaceId"
                  option-value="key"
                  option-text="value"
                  placeholder="مكان العمل"
                >
                </model-list-select>
              </div>
            </div>

            <!-- أزرار التحكم -->
            <div class="md-layout">
              <div class="md-layout-item md-size-100 mt-25 center-content">
                <md-button @click="addDetail" class="md-primary btn_nanosoft">
                  إضافة
                </md-button>
                <md-button
                  v-if="editingDetailIndex !== null"
                  @click="updateDetail"
                  class="md-warning btn_nanosoft"
                >
                  تحديث
                </md-button>
                <md-button
                  v-if="editingDetailIndex !== null"
                  @click="cancelEdit"
                  class="md-info btn_nanosoft"
                >
                  إلغاء
                </md-button>
              </div>
            </div>

            <!-- جدول التفاصيل -->
            <div class="md-layout mt-25" v-if="details.length > 0">
              <div class="md-layout-item md-size-100">
                <md-table
                  :value="details"
                  class="paginated-table table-striped table-hover"
                >
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item, index }"
                  >
                    <md-table-cell md-label="تاريخ المهمة">
                      {{ formatDate(item.taskDate) }}
                    </md-table-cell>
                    <md-table-cell md-label="اسم المهمة">
                      {{ getTaskName(item.typeOfTaskId) }}
                    </md-table-cell>
                    <md-table-cell md-label="وصف المهمة">
                      {{ item.taskDescription || "-" }}
                    </md-table-cell>
                    <md-table-cell md-label="مكان العمل">
                      {{ getWorkPlaceName(item.workPlaceId) }}
                    </md-table-cell>
                    <md-table-cell md-label="الحالة">
                      {{ item.taskStatusString }}
                    </md-table-cell>
                    <md-table-cell md-label>
                      <md-button
                        class="md-just-icon md-info md-simple ml-5"
                        @click.native="viewTaskDetails(item)"
                        title="عرض التفاصيل"
                      >
                        <md-icon>visibility</md-icon>
                      </md-button>
                      <md-button
                        class="md-just-icon md-warning md-simple ml-5"
                        @click.native="editDetail(index)"
                      >
                        <md-icon>edit</md-icon>
                      </md-button>
                      <md-button
                        class="md-just-icon md-danger md-simple"
                        @click.native="removeDetail(index)"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <!-- مودل عرض تفاصيل المهمة -->
    <md-dialog
      :md-active.sync="showDetailsDialog"
      class="task-details-dialog rtl-dialog"
    >
      <md-dialog-title>تفاصيل المهمة</md-dialog-title>
      <md-dialog-content v-if="selectedTaskDetail">
        <div class="task-details-content">
          <!-- صورة المهمة -->
          <div class="detail-section">
            <h5 class="detail-label">صورة المهمة:</h5>
            <div class="image-container">
              <img
                :src="
                  selectedTaskDetail.imagePath ||
                  require('@/assets/images/404.webp')
                "
                alt="صورة المهمة"
                class="task-image"
                @error="handleImageError"
              />
            </div>
          </div>

          <!-- وقت إنجاز المهمة -->
          <div class="detail-section">
            <h5 class="detail-label">وقت إنجاز المهمة:</h5>
            <p
              class="task-completed-time"
              v-if="selectedTaskDetail.completedAt"
            >
              {{ formatDateTime(selectedTaskDetail.completedAt) }}
            </p>
            <p class="no-data" v-else>لم يتم إنجاز المهمة بعد</p>
          </div>

          <!-- موقع المهمة -->
          <div
            class="detail-section"
            v-if="
              selectedTaskDetail.taskLocationLatitude &&
              selectedTaskDetail.taskLocationLongitude
            "
          >
            <h5 class="detail-label">موقع المهمة:</h5>
            <md-button
              @click="openGoogleMaps"
              class="md-raised md-primary location-button"
            >
              <md-icon>location_on</md-icon>
              عرض الموقع على خرائط جوجل
            </md-button>
          </div>
          <div class="detail-section" v-else>
            <p class="no-data">لا يوجد موقع للمهمة</p>
          </div>

          <!-- الملاحظات -->
          <div class="detail-section">
            <h5 class="detail-label">الملاحظات:</h5>
            <p class="task-note" v-if="selectedTaskDetail.taskNote">
              {{ selectedTaskDetail.taskNote }}
            </p>
            <p class="no-data" v-else>لا توجد ملاحظات</p>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDetailsDialog = false">
          إغلاق
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- مودل تقرير PDF -->
    <md-dialog :md-active.sync="showReportDialog" class="report-dialog">
      <md-dialog-title>تقرير PDF</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout">
          <div class="md-layout-item mt-25">
            <model-list-select
              class="input-must-rtl"
              :list="reportStatuses"
              v-model="reportStatus"
              option-value="key"
              option-text="value"
              placeholder="الحالة"
            >
            </model-list-select>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          style="margin-inline: 10px"
          :disabled="reportLoading"
          @click="downloadReport"
        >
          {{ reportLoading ? "جاري الطباعة..." : "طباعة" }}
        </md-button>
        <md-button @click="showReportDialog = false">إلغاء</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    ModelListSelect,
  },

  async created() {
    const id = this.$route.params.id;
    if (id) {
      await this.loadTypesOfTasks();
      await this.loadWorkPlaces();
      await this.loadTaskSchedule(id);
    }
  },

  data() {
    return {
      id: null,
      taskScheduleName: null,
      employeeId: null,
      fromDate: null,
      toDate: null,
      taskScheduleDuration: null,
      showTasksNotCompleted: false,
      isConfirmed: false,
      details: [],
      detail: {
        typeOfTaskId: null,
        taskDate: null,
        taskDescription: null,
        workPlaceId: null,
      },
      tableData: [],
      typesOfTasksData: [],
      workPlacesData: [],
      editingDetailIndex: null,
      showDetailsDialog: false,
      selectedTaskDetail: null,
      showReportDialog: false,
      reportStatus: null,
      reportLoading: false,
    };
  },

  computed: {
    employees() {
      const employeesData = this.$store.getters["global/employeesData"];
      return employeesData ? employeesData.employees : [];
    },

    typesOfTasks() {
      return this.typesOfTasksData.map((task) => ({
        key: task.id,
        value: task.taskName,
      }));
    },

    workPlaces() {
      return this.workPlacesData.map((place) => ({
        key: place.id,
        value: place.name,
      }));
    },

    taskScheduleDurations() {
      return [
        { key: 1, value: "شهري" },
        { key: 2, value: "أسبوعي" },
      ];
    },

    reportStatuses() {
      return [
        { key: 1, value: "غير منجزة" },
        { key: 2, value: "منجزة" },
      ];
    },
  },

  methods: {
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    async loadTaskSchedule(id) {
      try {
        const { data } = await this.$axios.get(`/api/TaskSchedule/${id}`);
        if (data.data) {
          this.id = data.data.id;
          this.taskScheduleName = data.data.taskScheduleName;
          this.employeeId = data.data.employeeId;
          this.fromDate = moment(data.data.fromDate).format("YYYY-MM-DD");
          this.toDate = moment(data.data.toDate).format("YYYY-MM-DD");
          this.taskScheduleDuration = data.data.taskScheduleDuration;
          this.showTasksNotCompleted = data.data.showTasksNotCompleted;
          this.isConfirmed = data.data.isConfirmed || false;
          this.details = data.data.details || [];
        }
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل البيانات");
        this.$router.push("/pages/tasks-schedule");
      }
    },

    async loadTypesOfTasks() {
      try {
        const { data } = await this.$axios.get(`/api/TypesOfTasks`);
        this.typesOfTasksData = data.data || [];
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل أنواع المهام");
      }
    },

    async loadWorkPlaces() {
      try {
        const { data } = await this.$axios.get(`/api/WorkPlaces`);
        this.workPlacesData = data.data || [];
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل أماكن العمل");
      }
    },

    addDetail() {
      if (this.editingDetailIndex !== null) {
        this.notifyVue("top", "center", "warning", "يرجى إنهاء التحديث أولاً");
        return;
      }

      if (!this.detail.typeOfTaskId) {
        this.notifyVue("top", "center", "warning", "يرجى اختيار اسم المهمة");
        return;
      }
      if (!this.detail.taskDate) {
        this.notifyVue("top", "center", "warning", "يرجى اختيار تاريخ المهمة");
        return;
      }

      this.details.push({
        typeOfTaskId: this.detail.typeOfTaskId,
        taskDate: this.detail.taskDate,
        taskDescription: this.detail.taskDescription,
        workPlaceId: this.detail.workPlaceId,
      });

      // إعادة تعيين نموذج التفاصيل
      this.detail.typeOfTaskId = null;
      this.detail.taskDescription = null;
      this.detail.workPlaceId = null;
    },

    removeDetail(index) {
      Swal.fire({
        text: "سيتم حذف هذا السطر، هل أنت متأكد؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.details.splice(index, 1);
          if (this.editingDetailIndex === index) {
            this.cancelEdit();
          }
          this.notifyVue("top", "center", "success", "تم الحذف بنجاح");
        }
      });
    },

    editDetail(index) {
      this.editingDetailIndex = index;
      const detailToEdit = this.details[index];
      this.detail.typeOfTaskId = detailToEdit.typeOfTaskId;
      this.detail.taskDate = moment(detailToEdit.taskDate).format("YYYY-MM-DD");
      this.detail.taskDescription = detailToEdit.taskDescription;
      this.detail.workPlaceId = detailToEdit.workPlaceId;
    },

    updateDetail() {
      if (!this.detail.typeOfTaskId) {
        this.notifyVue("top", "center", "warning", "يرجى اختيار اسم المهمة");
        return;
      }
      if (!this.detail.taskDate) {
        this.notifyVue("top", "center", "warning", "يرجى اختيار تاريخ المهمة");
        return;
      }

      const original = this.details[this.editingDetailIndex] || {};
      this.details[this.editingDetailIndex] = {
        ...original,
        typeOfTaskId: this.detail.typeOfTaskId,
        taskDate: this.detail.taskDate,
        taskDescription: this.detail.taskDescription,
        workPlaceId: this.detail.workPlaceId,
      };

      this.cancelEdit();
    },

    cancelEdit() {
      this.editingDetailIndex = null;
      this.detail = {
        typeOfTaskId: null,
        taskDate: null,
        taskDescription: null,
        workPlaceId: null,
      };
    },

    getEmployeeName(employeeId) {
      const employee = this.employees.find((emp) => emp.key === employeeId);
      return employee ? employee.value : "";
    },

    getTaskName(typeOfTaskId) {
      const task = this.typesOfTasksData.find((t) => t.id === typeOfTaskId);
      return task ? task.taskName : "";
    },

    getWorkPlaceName(workPlaceId) {
      const workPlace = this.workPlacesData.find((w) => w.id === workPlaceId);
      return workPlace ? workPlace.name : "";
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      return moment(dateString).format("YYYY-MM-DD");
    },

    formatDateTime(dateString) {
      if (!dateString) return "-";
      return moment(dateString).format("YYYY-MM-DD HH:mm");
    },

    viewTaskDetails(item) {
      this.selectedTaskDetail = item;
      this.showDetailsDialog = true;
    },

    openGoogleMaps() {
      if (
        this.selectedTaskDetail &&
        this.selectedTaskDetail.taskLocationLatitude &&
        this.selectedTaskDetail.taskLocationLongitude
      ) {
        const lat = this.selectedTaskDetail.taskLocationLatitude;
        const lng = this.selectedTaskDetail.taskLocationLongitude;
        const url = `https://www.google.com/maps?q=${lat},${lng}`;
        window.open(url, "_blank");
      }
    },

    handleImageError(event) {
      event.target.src = require("@/assets/images/404.webp");
    },

    async init() {
      try {
        const { data } = await this.$axios.get(`/api/TaskSchedule`);
        this.tableData = data.data || [];
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل البيانات");
      }
    },

    clear() {
      this.id = null;
      this.taskScheduleName = null;
      this.employeeId = null;
      this.fromDate = null;
      this.toDate = null;
      this.taskScheduleDuration = null;
      this.showTasksNotCompleted = null;
      this.details = [];
      this.detail = {
        typeOfTaskId: null,
        taskDate: null,
        taskDescription: null,
        workPlaceId: null,
      };
    },

    handleEdit(item) {
      this.id = item.id;
      this.taskScheduleName = item.taskScheduleName;
      this.employeeId = item.employeeId;
      this.fromDate = this.formatDate(item.fromDate);
      this.toDate = this.formatDate(item.toDate);
      this.taskScheduleDuration = item.taskScheduleDuration;
      this.showTasksNotCompleted = item.showTasksNotCompleted;
      this.details = item.details
        ? item.details.map((d) => ({
            typeOfTaskId: d.typeOfTaskId,
            taskDate: this.formatDate(d.taskDate),
            taskDescription: d.taskDescription,
            workPlaceId: d.workPlaceId,
          }))
        : [];

      // التمرير إلى أعلى الصفحة
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            const { data } = await this.$axios.delete(
              `/api/TaskSchedule/${item.id}`
            );
            if (data.message) {
              this.notifyVue("top", "center", "success", data.message);
              this.init();
            }
          } catch (error) {
            this.notifyVue("top", "center", "danger", "خطأ في الحذف");
          }
        }
      });
    },

    goToList() {
      this.$router.push("/pages/tasks-schedule/new");
    },

    openReportDialog() {
      this.reportStatus = null;
      this.showReportDialog = true;
    },

    async downloadReport() {
      this.reportLoading = true;
      try {
        const schema = {
          From: this.fromDate,
          To: this.toDate,
          status: this.reportStatus || null,
        };
        const response = await this.$axios.patch(
          `/api/TaskSchedule/DetailsReport/${this.id}`,
          schema,
          { responseType: "blob" }
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "تقرير جدول المهام.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.showReportDialog = false;
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل التقرير");
      } finally {
        this.reportLoading = false;
      }
    },

    async saveToDB() {
      try {
        // التحقق من البيانات الأساسية
        if (!this.taskScheduleName) {
          this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى إدخال اسم جدول المهام"
          );
          return;
        }
        if (!this.employeeId) {
          this.notifyVue("top", "center", "warning", "يرجى اختيار الموظف");
          return;
        }
        if (!this.fromDate) {
          this.notifyVue("top", "center", "warning", "يرجى اختيار تاريخ من");
          return;
        }
        if (!this.toDate) {
          this.notifyVue("top", "center", "warning", "يرجى اختيار تاريخ إلى");
          return;
        }
        if (this.details.length === 0) {
          this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى إضافة مهمة واحدة على الأقل"
          );
          return;
        }

        console.warn("this.details", this.details);

        const schema = {
          taskScheduleName: this.taskScheduleName,
          employeeId: this.employeeId,
          fromDate: this.formatDate(this.fromDate),
          toDate: this.formatDate(this.toDate),
          taskScheduleDuration: this.taskScheduleDuration,
          showTasksNotCompleted: this.showTasksNotCompleted,
          details: this.details.map((detail) => ({
            ...detail,
            taskDate: this.formatDate(detail.taskDate),
            taskName: detail.taskName,
            taskDescription: detail.taskDescription,
            imagePath: detail.imagePath,
            taskNote: detail.taskNote,
            typeOfTaskId: detail.typeOfTaskId,
            workPlaceId: detail.workPlaceId ? detail.workPlaceId : null,
            taskStatus: detail.taskStatus,
          })),
        };

        console.warn("schema", schema);

        let result = null;

        if (this.id) {
          // تحديث;
          const { data } = await this.$axios.put(
            `api/TaskSchedule/${this.id}`,
            schema
          );
          result = data;
        } else {
          // إضافة جديد
          const { data } = await this.$axios.post("api/TaskSchedule", schema);
          result = data;
        }

        if (result.message) {
          this.notifyVue("top", "center", "success", result.message);
          // // التحويل إلى صفحة المشاهدة بعد الحفظ
          // const savedId = result.data?.id || this.id;
          // if (savedId) {
          //   this.$router.push(`/pages/tasks-schedule/${savedId}`);
          // }
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          let result =
            error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ];
          return this.notifyVue("top", "center", "danger", result[0]);
        }

        if (error.response.data.message) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            error.response.data.message
          );
        }
        this.notifyVue(
          "top",
          "center",
          "danger",
          error.message || "حدث خطأ أثناء الحفظ"
        );
      }
    },

    async confirmTaskSchedule() {
      Swal.fire({
        text: "سيتم اعتماد جدول المهام، هل أنت متأكد؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            const { data } = await this.$axios.patch(
              `/api/TaskSchedule/confirm/${this.id}`
            );
            if (data.message) {
              this.notifyVue("top", "center", "success", data.message);
              this.isConfirmed = true;
            }
          } catch (error) {
            this.notifyVue(
              "top",
              "center",
              "danger",
              "خطأ في اعتماد جدول المهام"
            );
          }
        }
      });
    },

    async unconfirmTaskSchedule() {
      Swal.fire({
        text: "سيتم إلغاء اعتماد جدول المهام، هل أنت متأكد؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            const { data } = await this.$axios.patch(
              `/api/TaskSchedule/unConfirm/${this.id}`
            );
            if (data.message) {
              this.notifyVue("top", "center", "success", data.message);
              this.isConfirmed = false;
            }
          } catch (error) {
            this.notifyVue(
              "top",
              "center",
              "danger",
              "خطأ في إلغاء اعتماد جدول المهام"
            );
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.validate {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  display: inline;
}

// تنسيقات المودل
.task-details-dialog {
  ::v-deep .md-dialog-container {
    max-width: 600px;
    width: 90%;
  }
}

.rtl-dialog {
  ::v-deep .md-dialog {
    direction: rtl;
    text-align: right;
  }

  ::v-deep .md-dialog-title {
    text-align: right;
    padding-right: 24px;
  }

  ::v-deep .md-dialog-actions {
    justify-content: flex-start;
    padding-right: 24px;
  }
}

.task-details-content {
  padding: 20px;

  .detail-section {
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
    direction: rtl;
    text-align: right;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }

    .detail-label {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
      margin-top: 0;
    }

    .no-data {
      color: #999;
      font-style: italic;
      margin: 0;
    }
  }

  .image-container {
    text-align: center;
    margin-top: 10px;

    .task-image {
      max-width: 100%;
      max-height: 400px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      object-fit: contain;
    }
  }

  .location-button {
    margin: 0 !important;

    .md-icon {
      margin-left: 8px;
    }
  }

  .task-completed-time {
    background-color: #e3f2fd;
    padding: 12px 15px;
    border-radius: 6px;
    border-right: 4px solid #2196f3;
    margin: 0;
    font-size: 15px;
    font-weight: 500;
    color: #1976d2;
    text-align: right;
    direction: rtl;
  }

  .task-note {
    background-color: #f5f5f5;
    padding: 15px;
    border-radius: 6px;
    border-right: 4px solid #4caf50;
    margin: 0;
    line-height: 1.6;
    color: #333;
    text-align: right;
    direction: rtl;
  }

  .info-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;

    .info-item {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      background-color: #f9f9f9;
      border-radius: 4px;
      direction: rtl;
      text-align: right;

      .info-key {
        font-weight: 600;
        color: #555;
      }

      .info-value {
        color: #333;
      }
    }
  }
}

.report-dialog {
  direction: rtl;
  ::v-deep .md-dialog-container {
    max-width: 500px;
    width: 90%;
    overflow: visible;
    min-height: 300px;
  }
  ::v-deep .md-dialog-content {
    overflow: visible;
  }
}
</style>
